import { actions, selectors } from 'data'
import { Bank } from 'data/Payments/BankTransfer/types'
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import BankStatus from '../Yodlee/BankStatus'
import PlaidSDK from './PlaidSDK'

type Props = {
  onBack: () => void
  onSuccess: (bank: Bank) => void
  refresh?: boolean
}

const Plaid = ({ onBack, onSuccess, refresh }: Props) => {
  const bank = useSelector(selectors.payments.bankTransfer.getNewLinkedBank)
  const dispatch = useDispatch()
  const [pollingBank, setPollingBank] = useState<boolean>(false)

  if (!bank || bank.partner !== 'PLAID' || !bank.attributes) {
    // Unexpected!
    return null
  }

  if (pollingBank) {
    return <BankStatus bankId={bank.id} onBack={onBack} onDone={onSuccess} />
  }

  return (
    <PlaidSDK
      token={bank.attributes.link_token}
      onBack={onBack}
      onSuccess={(public_token, metadata) => {
        if (!refresh) {
          dispatch(
            actions.payments.updateBankLink(bank.id, {
              accountId: metadata.accounts[0]?.id || '',
              public_token
            })
          )
        }
        setPollingBank(true)
      }}
    />
  )
}

export default Plaid
